/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCommitmentRequest } from '../../models/profile-commitment-request';
import { ProfileCommitmentResponse } from '../../models/profile-commitment-response';

export interface UpdateCommitmentForProfile$Params {
  profileId: number;
  id: number;
      body: ProfileCommitmentRequest
}

export function updateCommitmentForProfile(http: HttpClient, rootUrl: string, params: UpdateCommitmentForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCommitmentResponse>> {
  const rb = new RequestBuilder(rootUrl, updateCommitmentForProfile.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileCommitmentResponse>;
    })
  );
}

updateCommitmentForProfile.PATH = '/rest/profile/{profileId}/commitment/{id}';
